import React from 'react'

export default ({
  className = ''
}) => (
<svg className={`${className} cancel_svg`} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 94.406 67.314"><path d="M0,62.736l12.3-7.689v-35.2L41.529.806,42.773,0l1.246.806L70.987,18.379,91.545,5.532l2.86,4.577L73.243,23.334v37.6H13.065L2.86,67.314ZM68.555,56.25V26.263L20.566,56.25ZM16.993,52.118,37.975,39.007,16.993,25.415Zm1.9-31.025,23.452,15.18,24.3-15.183L42.773,5.567Z"/></svg>
  )
